import { Checkbox, MenuItem } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { ADDITIONAL_TAGS } from "../../AssetsFilterTags.constants";

interface AdditionalTagsListProps {
  selectedTagIds: number[];
  onToggle: (tagId: number) => void;
}

export default function AdditionalTagsList({
  selectedTagIds,
  onToggle,
}: AdditionalTagsListProps) {
  if (ADDITIONAL_TAGS.length === 0) return null;

  return (
    <>
      {ADDITIONAL_TAGS.map((tag) => (
        <MenuItem
          key={tag.tag_id}
          value={tag.tag_id}
          sx={{ paddingY: 0, paddingX: 0.5 }}
        >
          <Checkbox checked={selectedTagIds.includes(tag.tag_id)} size="small" />
          <ListItemText primary={tag.name} />
        </MenuItem>
      ))}
    </>
  );
}
